var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellLockColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 14,
    height: 12,
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4L8 16",
    stroke: "#172664",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.33333C3.44444 7.88889 6.51852 5.92593 8 5",
    stroke: "#172664"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.6663C3.44444 11.2219 6.51852 9.25893 8 8.33301",
    stroke: "#172664"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.0003C3.44444 14.5559 6.51852 12.5929 8 11.667",
    stroke: "#172664"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellLockColumns);
export default __webpack_public_path__ + "static/media/icn_table_cell_Lock_Columns.5a44d19e518b225d43c872100ed086e6.svg";
export { ForwardRef as ReactComponent };